import React from "react";
import { Helmet } from "react-helmet";
import ListFormTemplate from "../../PageTemplate/ListFormTemplate";

const columns = [
  //{ field: 'id', label: 'ID', allowSorting: false },
  { field: "name", label: "Name", allowSorting: true },
];

const fields = [
  {
    name: "name",
    label: "Vehicle Service Type Name",
    type: "text",
    isRequired: true,
    err: "Vehicle Service Type Name is required",
  },
  // Add more fields as needed
];

//Roles
const admin = process.env.REACT_APP_ADMIN_ROLE;

///Add,Delete,Edit Roles
const addRoles = [admin];
const deleteRoles = [admin];
const editRoles = [admin];

const ServiceTypesPage = () => {
  return (
    <div>
      <Helmet>
        <title>Car2Go - Service Types</title>
        <meta name="description" content="Welcome to the Service Types." />
        {/* Other meta tags */}
      </Helmet>
      <ListFormTemplate
        apiRoute={"servicetypes"}
        columns={columns}
        fields={fields}
        createRoles={addRoles}
        deleteRoles={deleteRoles}
        editRoles={editRoles}
        enhancedTable={true}
      />
    </div>
  );
};

export default ServiceTypesPage;
